<template>

    <transition name="dropdown">
        <div v-if="toggle && target" class="emoji-selector" :style="styles">
            <div class="emoji-selector-body">
                <VEmojiPicker
                    :continuousList="true"
                    :dark="false"
                    :emoji-size="30"
                    :emoji-with-border="false"
                    :emojis-by-row="8"
                    :show-categories="false"
                    @select="selectEmoji">
                </VEmojiPicker>
            </div>
            <div class="emoji-selector-footer">
                <v-button size="xs" btn-style="white" @click.native="close">Cancel</v-button>
            </div>
        </div>
    </transition>

</template>

<style lang="scss">

    .emoji-selector {
        .emoji-picker {
            background: #fff !important;
            border: none;
            max-width: 300px;
            width: 300px;
            .container-search {
                background: #fff;
                margin: 0;
                padding: 15px 15px 0 15px;
                input {
                    @include font-medium(13px);
                    background: #fff;
                    border: 1px solid $color-rule;
                    border-radius: 3px;
                    color: $color-text;
                    height: 40px;
                    padding: 0 12px;
                    transition: border-color .3s;
                    &:hover, &:focus {
                        border-color: $color-text;
                    }
                }
            }
            .container-emoji {
                background: #fff;
                border: none;
                box-sizing: border-box;
                height: 200px;
                margin: 0;
                overflow-y: auto;
                padding: 15px;
            }
            .category-title {
                @include font-medium(12px);
                color: $color-text;
                padding: 0;
                text-transform: none;
            }
            .emoji {
                border-radius: 3px;
                transform: none !important;
                &:hover {
                    background-color: $color-bg;
                }
            }
        }
    }

</style>

<style scoped lang="scss">

    .emoji-selector {
        @include shad(2);
        background: #fff;
        border: 1px solid $color-rule;
        border-radius: 5px;
        left: 0;
        overflow: hidden;
        position: fixed;
        top: 0;
        width: 300px;
        z-index: 1000;
        .emoji-selector-body {
            padding: 0;
        }
        .emoji-selector-footer {
            display: flex;
            justify-content: flex-start;
            padding: 10px;
        }
    }

</style>

<script>

import { VEmojiPicker } from 'v-emoji-picker';

export default {

    components: {
        VEmojiPicker,
    },

    props: {
        toggle: {
            type: HTMLElement,
        },
        target: {
            type: HTMLElement,
        },
    },

    data() {
        return {
            error: null,
            selectedTarget: null,
            range: null,
            styles: {},
            params: {},
        }
    },

    watch: {

        toggle(val) {
            this.error = null;
            this.params = {};
            if (val) {
                this.selectedTarget = window.getSelection().anchorNode?.parentNode;
                this.range = window.getSelection().rangeCount >= 1 ? window.getSelection().getRangeAt(0) : null;
                let rectToggle = this.toggle.getBoundingClientRect();
                let x = rectToggle.left + rectToggle.width - 300;
                let y = rectToggle.top + rectToggle.height + 2;
                this.styles = { left: x + 'px', top: y + 'px' };
            }
        },

    },

    methods: {

        selectEmoji(emoji) {
            if (['INPUT', 'TEXTAREA'].includes(this.target.tagName)) {
                this.target.focus();
                document.execCommand('insertText', false, emoji.data);
            } else if (this.range && this.selectedTarget === this.target) {
                let sel = window.getSelection();
                sel.removeAllRanges();
                sel.addRange(this.range);
                sel.getRangeAt(0).insertNode(document.createTextNode(emoji.data));
                sel.empty();
            } else {
                this.target.appendChild(document.createTextNode(emoji.data));
            }
            this.$emit('close');
        },

        close() {
            this.$emit('close');
        },

    },

}

</script>
